<template>
  <div class="active-goods-list">
    <!--检索-->
    <!-- <el-row>
      <el-col>
        <el-form :inline="true" :model="requestData" label-width="120px" style="text-align: right">
          <el-form-item>
            <el-input clearable size="medium" :placeholder="placeholder" v-model="searchText">
            </el-input>
          </el-form-item>
          <el-form-item>
            <el-button size="medium" @click="search">搜索</el-button>
          </el-form-item>
          <el-form-item>
            <el-upload
                    class="upload-demo"
                    action="https://yytools-api.mockuai.com/api/test/excel/upload"
                    :on-change="handleChange"
                    :on-exceed="handleExceed"
                    :on-remove="handleRemove"
                    :on-success="excelSuccess"
                    :show-file-list="false"
                    :limit="limitUpload"
                    :auto-upload="true">
              <el-button size="small" type="primary">导入excel</el-button>
            </el-upload>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row> -->
    <!-- tips -->
    <!--表格数据-->
    <el-table
      :data="tableData"
      v-loading="loading"
      stripe
      ref="mulitTable"
      height="490"
      style="width: 100%; margin-top: 20px"
      @select-all="allSelect"
      @select="selectStore"
    >
      <el-table-column type="selection" width="100"> </el-table-column>

      <el-table-column width="100" label="商品图">
        <template slot-scope="scope">
          <img width="90" height="90" :src="scope.row.icon" alt="" />
        </template>
      </el-table-column>

      <el-table-column label="名称">
        <template slot-scope="scope">
          {{ scope.row.item_name }}
        </template>
      </el-table-column>

      <el-table-column width="100" label="粉丝购买价">
        <template slot-scope="scope">
          {{ (scope.row.live_price || 0) / 100 }}
        </template>
      </el-table-column>
      <el-table-column width="100" label="佣金比">
        <template slot-scope="scope">
          {{ (scope.row.live_commission_percent || 0) / 100 }}%
        </template>
      </el-table-column>
      <el-table-column width="100" label="预计赚">
        <template slot-scope="scope">
          {{ (scope.row.live_promotion_profit || 0) / 100 }}
        </template>
      </el-table-column>
      <el-table-column width="200" label="运营标签">
        <template slot-scope="{ row }">
          <div v-for="(item, i) in row.operation_tags" class="operation_tags">
            <el-input
              placeholder="请输入内容"
              v-model="item.tag"
              size="mini"
              :maxlength="15"
              class="ipt"
            ></el-input>
            <i
              class="el-icon-plus curp"
              v-if="row.operation_tags.length !== 3"
              @click="addTags(row, i)"
            ></i>
            <i
              class="el-icon-remove curp"
              v-if="row.operation_tags.length !== 1"
              @click="delTags(row, i)"
            ></i>
          </div>
        </template>
      </el-table-column>

      <el-table-column fixed prop="" label="操作" width="100" align="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="
              select(scope.row, idList.indexOf(scope.row.id), scope.$index)
            "
            v-text="idList.indexOf(scope.row.id) !== -1 ? '已选取' : '选取'"
          ></el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- <div v-if="tableData" class="pagination-wrapper">
      <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage" :page-size="requestData.count" layout="total, prev, pager, next" :total="totalNumber">
      </el-pagination>
    </div> -->
    <el-row type="flex" justify="center">
      <div class="bottom-btn-box">
        <el-button class="btn-long" type="primary" @click="closeDialog"
          >关闭</el-button
        >
      </div>
    </el-row>
  </div>
</template>

<script type="text/ecmascript-6">
import Util from "@/js/util";

export default {
  props: {
    // 请求的URL
    url: {
      default: "",
      type: String,
    },
    // 默认请求参数
    params: {
      default: function () {
        return {};
      },
      type: Object,
    },
    // 页面配置
    pageData: {
      default: {},
      type: Object,
    },
    // 名称搜索字段
    searchField: {
      default: "name_like",
      type: String,
    },
    // placeholder
    placeholder: {
      default: "根据商品id进行搜索添加",
      type: String,
    },
    // 价格字段
    priceField: {
      default: "promotion_price",
      type: String,
    },
    // 标题字段
    titleField: {
      default: "name",
      type: String,
    },
    // 服务端返回的数组名称
    resultArrayName: {
      default: "item_list",
      type: String,
    },
    // 分页数量
    count: {
      default: 20,
      type: Number,
    },
    // 是否支持多选
    multi: {
      type: Boolean,
      default: false,
    },
    // 已选中的idlist
    idList: {
      type: Array,
      default: [],
    },
    config: {},
  },
  data() {
    return {
      multipleSelection: [],
      limitUpload: 1,
      fileTemp: null,

      searchText: "",
      // 表格数据 & 翻页
      tableData: null,
      totalNumber: null,
      currentPage: 1,
      loading: false,
      requestData: {
        // 翻页参数
        // offset: 0,
        // count: 20
      },
      channel: [
        {
          name: "快手",
          id: 10,
        },
        {
          name: "花椒",
          id: 20,
        },
        {
          name: "KK",
          id: 30,
        },
        {
          name: "虎牙",
          id: 40,
        },
      ],
      selectOptions: {
        status: [
          { value: 1, text: "上架" },
          { value: 2, text: "下架" },
        ],
      },
    };
  },
  watch: {
    config: {
      handler(val) {
        console.log(val, 111);
      },
      deep: true,
      immediate: true,
    },
    // url(val) {
    //   this.searchText = "";
    //   Object.assign(this.requestData, this.params);
    //   this.request();
    // },
    // params(val) {
    //   this.searchText = "";
    //   Object.assign(this.requestData, this.params);
    //   this.request();
    // },
    newParams: {
      handler(val) {
        if (!val.params.id) return;
        if (!val.url) return;
        this.request();
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.requestData.count = this.count;
    //    this.request();
  },
  computed: {
    newParams() {
      return {
        url: this.url,
        params: {
          ...this.requestData,
          ...this.params,
        },
      };
    },
  },
  methods: {
    handleChange(file, fileList) {
      this.fileTemp = file.raw;
    },
    addTags(row) {
      row.operation_tags.push({ tag: "" });
    },
    delTags(row, i) {
      row.operation_tags.forEach((el, index, arr) => {
        if (i == index) {
          arr.splice(i, 1);
        }
      });
    },
    handleRemove(file, fileList) {
      this.fileTemp = null;
    },
    handleExceed() {},
    excelSuccess(res) {
      if (res.data && res.data.length) {
        let idList = [];
        res.data.forEach((item) => {
          if (item && item.ID) {
            idList.push(item.ID);
          }
        });
        this.requestIdList(idList);
      }
    },
    requestIdList(idList) {
      lib.api.post({
        api: "ec/b/item/query/composite/item",
        data: {
          item_id_list: JSON.stringify(idList),
        },
        success: (res) => {
          if (res.data && res.data.data && res.data.data.length) {
            res.data.data.forEach((item) => {
              item.promotion_price = Util.filterPrice(item.promotion_price);
              if (item.channel_labels) {
                item.channel_tags = this.getItemChannel(
                  item.channel_labels.split(" ")
                );
              }
            });
          }

          this.tableData = res.data.data;
          this.totalNumber = res.data.data.total_count;
          if (this.pageData.app_type == "seller") {
            this.tableData.forEach((item, index) => {
              this.getSellerItem(item.id, index);
            });
          }

          //          data.data.
          //          if(data.data.item && data.data.item.channel_labels){
          //            this.getItemChannel(data.data.item.channel_labels.split(' '));
          //          }

          //          if(this.pageData.app_type == 'seller'){
          //            this.getSellerItem();
          //            console.log('选择卖家商品')
          //          }else{
          //            console.log('选择买家商品')
          //          }
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    request() {
      // 有搜索字段时才设置搜索信息
      // if(!this.searchText){
      //   return;
      // }
      Object.assign(this.requestData, this.params);
      this.loading = true;
      lib.api.get({
        api: this.url,
        data: this.newParams.params,
        success: (res) => {
          // data.data.item.promotion_price = Util.filterPrice(data.data.item.promotion_price);
          // this.tableData = [data.data.item];
          // this.totalNumber = data.data.total_count;
          // if(data.data.item && data.data.item.channel_labels){
          //   this.tableData[0].channel_tags = this.getItemChannel(data.data.item.channel_labels.split(' '));
          // }
          // res.data.forEach(el => {
          //   el.live_price =  Util.filterPrice( el.live_price )
          //   el.live_commission_percent = `${(el.live_commission_percent || 0) / 100} %`
          //    el.live_promotion_profit = `${(el.live_promotion_profit || 0) / 100} %`
          // })
          res.data.forEach((el) => {
            el.operation_tags = [{ tag: "" }];
          });
          this.tableData = res.data;
          this.handleSelectionChange();
          this.loading = false;
          // if(this.pageData.app_type == 'seller'){
          //   this.getSellerItem(this.searchText);
          //   console.log('选择卖家商品')
          // }else{
          //   console.log('选择买家商品')
          // }
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    getItemChannel(channel_tags) {
      let tempTags = [];
      let tags = "";
      if (channel_tags && channel_tags.length) {
        channel_tags.forEach((item) => {
          switch (item) {
            case "10":
              tempTags.push("快手");
              break;
            case "20":
              tempTags.push("花椒");
              break;
            case "30":
              tempTags.push("kk直播");
              break;
            case "40":
              tempTags.push("虎牙");
              break;
            case "50":
              tempTags.push("映客");
              break;
            case "60":
              tempTags.push("斗鱼");
              break;
            case "70":
              tempTags.push("企鹅小店");
              break;
            case "80":
              tempTags.push("无敌主播");
              break;
            case "90":
              tempTags.push("微视");
              break;
            case "100":
              tempTags.push("全民K歌");
              break;
            case "110":
              tempTags.push("手Q");
              break;
            case "120":
              tempTags.push("魔筷星选");
              break;
            default:
              break;
          }
        });
        tags = tempTags.toString();
      } else {
        tags = "-";
      }
      return tags;
    },
    getSellerItem(item_id, index = 0) {
      lib.api.get({
        api: "ec/c/item/discount/price/get",
        data: { item_id: item_id },
        success: (data) => {
          this.tableData[index].app_type = "seller";
          this.tableData[index].commission_percent =
            data.data.item.commission_percent;
          this.tableData[index].promotion_profit =
            data.data.item.promotion_profit;
        },
        error: (data) => {
          if (data.code == 50004) {
            lib.login.goLogin();
          }
          this.$message.error(data.msg || "请求失败!");
        },
        complete: () => {},
      });
    },
    search() {
      this.request();
    },
    select(row, index, row_idx) {
      // row.operation_tags.forEach((el, i, arr) => {
      //   if (el.tag == '' || el.tag == undefined || el.tag == null) {
      //     arr.splice(i, 1)
      //   }
      // })
      this.$refs.mulitTable.toggleRowSelection(this.tableData[row_idx]);

      if (this.multi) {
        if (index === -1) {
          if (this.idList.length >= 50) {
            this.$message.error("最多添加50个!");
            return;
          }
          this.$emit("select", row);
        } else {
          this.$emit("unSelect", row, index);
        }
      } else {
        this.$emit("select", row);
      }
    },

    handleCurrentChange(val) {
      this.requestData.offset = this.requestData.count * (val - 1) || 0;
      this.request();
    },
    closeDialog() {
      this.$emit("close");
    },
    allSelect(selection) {
      this.$emit("allSelect", selection);
    },
    selectStore(selection, row) {
      if (this.multi) {
        if (this.idList.indexOf(row.id) === -1) {
          if (this.idList.length >= 50) {
            this.$message.error("最多添加50个!");
            return;
          }
          this.$emit("select", row);
        } else {
          this.$emit("unSelect", row, this.idList.indexOf(row.id));
        }
      } else {
        this.$emit("select", row);
      }
    },
    handleSelectionChange() {
      console.log("执行了没有");
      // 判断已选的商品
      this.$nextTick(() => {
        if (this.tableData.length) {
          this.tableData.forEach((v, i) => {
            if (this.idList.includes(v.id)) {
              this.$refs.mulitTable.toggleRowSelection(v);
            }
          });
        }
      });
    },
    removerIdList(id) {
      // console.log("删除的下标", index);

      let index = this.tableData.findIndex((v) => v.id === id);
      this.$refs.mulitTable.toggleRowSelection(this.tableData[index]);
    },
  },
};
</script>

<style lang="scss" scoped>
.active-goods-list {
  height: 600px;
  overflow: auto;
}
.operation_tags {
  display: flex;
  align-items: center;
}
.curp {
  cursor: pointer;
}
.ipt {
  width: 150px;
  margin-right: 5px;
  margin-bottom: 5px;
}
</style>
